import { render, staticRenderFns } from "./TabPosition.vue?vue&type=template&id=7cdcedbf"
import script from "./TabPosition.vue?vue&type=script&lang=js"
export * from "./TabPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports